import { parseISO } from 'date-fns';
import { Input } from '../Form';
import DatePicker from 'react-datepicker';
import React from 'react';
import { createPortal } from 'react-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker.css';
import Icon from '../Icon/Icon';
import { Flex } from 'rebass';

const PopperContainer: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return createPortal(children, document.body);
};

type DateTimePickerProps = {
  selected?: string | null | Date;
  onChange?: (date: string | null) => void;
  autoFocus?: boolean;
  minDate?: Date;
  maxDate?: Date;
  variant?: 'inputSquare' | 'input' | 'inputRoundedRight' | 'inputRoundedLeft';
  placeholderText?: string;
};

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  selected,
  onChange,
  autoFocus,
  minDate,
  maxDate,
  variant = 'input',
  placeholderText,
}) => {
  const selectedDate =
    typeof selected === 'string'
      ? parseISO(selected)
      : selected instanceof Date
        ? selected
        : null;

  return (
    <DatePicker
      selected={selectedDate}
      onChange={(date) => {
        onChange?.(date ? date.toISOString() : null);
      }}
      customInput={
        <Input
          variant={variant}
          sx={{ cursor: 'default' }}
          width={210}
          autoComplete="off"
        />
      }
      showIcon
      icon={
        <Flex
          alignItems="center"
          sx={{ pointerEvents: 'none' }}
          justifyContent="center"
        >
          <Icon size="13" icon="calendar" />
        </Flex>
      }
      isClearable
      showTimeSelect
      dateFormat="MMM d, yyyy h:mm aa"
      minDate={minDate}
      maxDate={maxDate}
      autoFocus={autoFocus}
      placeholderText={placeholderText}
      popperContainer={PopperContainer}
      popperProps={{ strategy: 'fixed' }}
    />
  );
};
